import * as React from "react"

import { ChevronDown } from "@iyk/icons"
import { cva, cx } from "../cva.ts"
import { useFieldRefs } from "../forms.ts"
import { withClass } from "../to-wrapped-children.ts"

/** Native single-select combobox. */
export const Select = ({ className, ...props }: Select.Props) => {
  const field = useFieldRefs()

  return (
    <div className={cx("relative w-stretch", className)}>
      <select
        name={field.name}
        id={field.uuid("control")}
        required={field.required}
        {...withClass(props, classForSelect)}
      />
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-gray-11" />
    </div>
  )
}

export namespace Select {
  export interface Props extends React.ComponentProps<"select"> {}
}

export const classForSelect = cva([
  "flex w-full pl-3 pr-10 py-2 outline-none",
  "bg-background text-sm text-gray-12",
  "appearance-none",
  "bshadow bshadow-gray-4 rounded-sm transition-all",
  "placeholder:text-gray-10",
  "autofill:bg-transparent",
  "disabled:cursor-not-allowed disabled:placeholder:text-gray-8",
  "focus-visible:ring-2",
  "truncate",
])
